import { useState } from 'react'
import { Button, ListItemText, Menu, MenuItem } from '@mui/material'
import { ChevronDown, Download } from 'lucide-react'
import { download } from '../../api/client'

const FORMATS = [
  { ext: 'csv', label: 'CSV', detail: 'A row per issue, every plot listed' },
  { ext: 'geojson', label: 'GeoJSON', detail: 'Shapes with their status and issues' },
  { ext: 'kml', label: 'KML', detail: 'For Google Earth, coloured by status' },
] as const

/** "Export all plots", in the format chosen: every plot in the region, passed ones included. */
export function ExportPlots({ runId, onError }: { runId: string; onError: (message: string) => void }) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const [busy, setBusy] = useState(false)

  const exportAs = async (ext: (typeof FORMATS)[number]['ext']) => {
    setAnchor(null)
    setBusy(true)
    try {
      await download(`/runs/${runId}/export.${ext}?scope=all&delivery=link`, `polygon-checks-${runId.slice(0, 8)}-all.${ext}`)
    } catch (err) {
      onError((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        disabled={busy}
        startIcon={<Download size={14} strokeWidth={1.5} />}
        endIcon={<ChevronDown size={14} strokeWidth={1.5} />}
        aria-haspopup="menu"
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        {busy ? 'Exporting…' : 'Export all plots'}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {FORMATS.map((f) => (
          <MenuItem key={f.ext} onClick={() => exportAs(f.ext)}>
            <ListItemText primary={f.label} secondary={f.detail} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
